/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpBigQueryResourceTablesInner {
  /**
  * Table name.
  */
  'name'?: string;
  /**
  * Table type (TABLE, EXTERNAL_TABLE, VIEW, MATERIALIZED_VIEW).
  */
  'type'?: string;
  /**
  * Storage billing model (LOGICAL or PHYSICAL).
  */
  'storageBillingModel'?: string;
  /**
  * Number of rows in the table.
  */
  'numRows'?: number;
  /**
  * Table logical storage size in bytes.
  */
  'totalLogicalBytes'?: number;
  /**
  * Table physical storage size in bytes.
  */
  'totalPhysicalBytes'?: number;
  /**
  * Active logical storage size in bytes.
  */
  'activeLogicalBytes'?: number;
  /**
  * Long-term logical storage size in bytes.
  */
  'longTermLogicalBytes'?: number;
  /**
  * Active physical storage size in bytes.
  */
  'activePhysicalBytes'?: number;
  /**
  * Long-term physical storage size in bytes.
  */
  'longTermPhysicalBytes'?: number;
  /**
  * Table time travel physical storage size in bytes.
  */
  'timeTravelPhysicalBytes'?: number;
  /**
  * KMS encryption key name.
  */
  'kmsKeyName'?: string;
  /**
  * Table creation time.
  */
  'creationTime'?: Date;
  /**
  * Table last modification time.
  */
  'lastModifiedTime'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageBillingModel",
      "baseName": "storageBillingModel",
      "type": "string",
      "format": ""
    },
    {
      "name": "numRows",
      "baseName": "numRows",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "totalLogicalBytes",
      "baseName": "totalLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "totalPhysicalBytes",
      "baseName": "totalPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activeLogicalBytes",
      "baseName": "activeLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermLogicalBytes",
      "baseName": "longTermLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activePhysicalBytes",
      "baseName": "activePhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermPhysicalBytes",
      "baseName": "longTermPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "timeTravelPhysicalBytes",
      "baseName": "timeTravelPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "kmsKeyName",
      "baseName": "kmsKeyName",
      "type": "string",
      "format": ""
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastModifiedTime",
      "baseName": "lastModifiedTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return GcpBigQueryResourceTablesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

